export default __webpack_public_path__ + "static/media/gallery_08.867cb6bc.jpg";